<template>
    <div class="container-fluid" >
        <headerApp :title="this.translate('currentAccount')"></headerApp>
        <div class="row">
            <div class="col-xs-24">
                <div class="col-container">
                    <div class="row">
                        <div id='form' class='form col-xs-11 form-label'>
                            <label for="desde">
                                {{ this.translate('desde') }}
                                <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" :class="'pull-right'"></svg-item>
                            </label>
                            <input id="desde" type="date" v-model="desde" @change="dateChange" :max="hasta">
                        </div>
                        <div id='form' class='form col-xs-offset-2 col-xs-11 form-label'>
                            <label for="hasta">
                                {{ this.translate('hasta') }}
                                <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" :class="'pull-right'"></svg-item>
                            </label>
                            <input id="hasta" type="date" v-model="hasta" @change="dateChange" :max="hoy" :min="desde">
                        </div>
                    </div>
                    <div id='form' class='form row'>
                        <h1 v-show="movements.length > 0">
                            {{ this.translate('totalMovements') }}:
                            {{ movements.length }}
                        </h1>
                        <h1 v-show="movements.length == 0">
                            {{ this.translate('noMovements') }}
                        </h1>

                        <div v-for="item in movements" class="movement-item" v-bind:key="item.id">
                            <div class="row" v-if="item.created_at">
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'calendar'"  :color="'--text-color'" aria-label="Fecha"></svg-item>
                                    {{ [ item.created_at  ] | moment("DD/MM/YYYY") }}
                                </div>
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'time'"  :color="'--text-color'" aria-label="Hora">></svg-item>
                                    {{ [ item.created_at  ] | moment("HH:mm") }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-24">
                                    <svg-item size="24" :icon="'movement'"  :color="'--text-color'"  aria-label="Movimiento">></svg-item>
                                    {{ item.descripcion }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-24">
                                    <svg-item size="24" :icon="'status'"  :color="'--text-color'"  aria-label="Movimiento">></svg-item>
                                    {{ item.status }}
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'money-fill'"  :color="'--main-color'"  aria-label="cantidad">></svg-item>
                                    {{ parseFloat(item.cantidad).toFixed(2) }}
                                </div>
                                <div class="col-xs-12">
                                    <svg-item size="24" :icon="'money-fill'"  :color="'--secondary-color'"  aria-label="saldo">></svg-item>
                                    {{ parseFloat(item.saldo).toFixed(2) }}
                                </div>
                            </div>
                            <hr />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';

export default {
    name: 'currentAccount',
    data () {
        return {
            desde: moment().subtract(7, 'days').format('YYYY-MM-DD'),
            hasta: moment().format('YYYY-MM-DD'),
            hoy: moment().format('YYYY-MM-DD')
        };
    },
    computed: {
        ...mapGetters({
            movements: 'currentAccount/movements',
            settings: 'company/config'
        })
    },
    mounted () {
        this.language = this.$getLang();
        this.getCurrentAccount({
            desde: this.desde,
            hasta: this.hasta
        });
    },
    methods: {
        ...mapActions({
            getCurrentAccount: 'currentAccount/get'
        }),
        dateChange () {
            this.getCurrentAccount({
                desde: this.desde,
                hasta: this.hasta
            });
        }
    }
};
</script>

<style scoped>
    .container-fluid {
        background: var(--form-background-color);
        min-height: 100%;
    }
    .col-container {
        padding: 0 .4em;
    }
   .form {
        padding: 1.4em;
        background-color: white;
        box-shadow: 0px 1px 5px 3px rgba(0, 0, 0, .1);
        margin-top: 1.2em;
        margin-bottom: 1.2em;
    }
    .form-label {
        border-radius: 10px;
    }
    p {
        margin-top: 0;
    }
    h1 {
        font-weight: normal;
        margin-bottom: 1em;
    }
    label {
        display: block;
    }
    .movement-item {
        margin-bottom: 1.5em;
        font-size: 0.8rem;
    }
    .movement-item hr {
        border-color: var(--text-color);
    }
    .movement-item .row{
        margin-top: .8em;
    }
    [type=date] {
        -webkit-appearance: none;
        background: transparent;
        border: 0;
        padding: .5em 0;
        width: 100%;
    }
    .driver-profile-photo {
        display: inline-block;
    }
    .driver-description {
        display:inline-block;
        vertical-align: middle;
        margin-left: 5px;
    }
</style>



// WEBPACK FOOTER //
// src/components/views/AccountMovements.vue